import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  indexByEntry(parentId, params = {}) {
    return httpAdminClient.get(`/admin/train/entries/${parentId}/homeworks`, { params });
  },
  indexByTask(parentId, params = { per_page: 999 }) {
    return httpAdminClient.get(`/admin/train/tasks/${parentId}/homeworks`, { params });
  },
  find(id) {
    return httpAdminClient.put(`/admin/train/homeworks/${id}`);
  },
  export(parentId, params = { per_page: 999 }) {
    return httpAdminClient.get(`/admin/train/tasks/${parentId}/homeworks/export`, { params });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/train/api-homework.js